/* ***************************** ENTITY ***************************** */

export const PARAM_TABLE_ENTITY = "ParamTable"
export const TENANT_ENTITY = "Tenant"
export const TENANT_GROUP_ENTITY = "TenantGroup"

/* ****************************** GRID ****************************** */

export const PARAM_TABLE_LIST = "paramTableList"



// WEBPACK FOOTER //
// ./src/core/tenant/constants.ts